/**
 * Rugby League incident IDs.
 * Event/status IDs (NotStarted–ToFinish) from API sport show (sport_id 79).
 * Match incident IDs (Try, ConversionGoal, etc.) are placeholders until API provides them.
 */
export enum RugbyLeagueIncidentId {
  NotStarted = 2721,
  StartDelayed = 2725,
  FirstHalf = 2727,
  Halftime = 2728,
  SecondHalf = 2729,
  Extratime = 2733,
  ExtratimeFirstHalf = 2735,
  ExtratimeSecondHalf = 2736,
  FinishedRegularTime = 2730,
  FinishedAfterExtratime = 2732,
  FinishedAwardedWin = 2731,
  Interrupted = 2722,
  Postponed = 2724,
  Abandoned = 2726,
  Cancelled = 2723,
  ToFinish = 2734,
  RefereeReview = 3037,
  BreakDuringGame = 3038,
  ExtratimeHalftime = 3039,
  PenaltiesStarted = 3040,
  FinishedAfterPenalties = 3041,
  WaterBreak = 3042,
  FreeKick = 3021,
  InPossession = 3022,
  EntryInto20 = 3023,
  Kick = 3024,
  GoallineDropout = 3025,
  Offload = 3026,
  Turnover = 3027,
  Foul = 3028,
  TackleMade = 3029,
  TackleBreak = 3030,
  Scrum = 3031,
  Lineout = 3032,
  Injury = 3033,
  Timeout = 3034,
  Kickoff = 3035,
  MedicalTimeout = 3036,
  MatchAboutToStart = 3044,
  WaitingForExtratime = 3045,
  WaitingForPenalty = 3046,
  Try = 3006,
  PenaltyTry = 3007,
  ConversionGoal = 3008,
  ConversionMissed = 3009,
  ConversionAttempt = 3010,
  PenaltyKickGoal = 3011,
  PenaltyKickMissed = 3012,
  PenaltyAwarded = 3013,
  DropGoal = 3014,
  DropGoalMissed = 3015,
  YellowCard = 3016,
  RedCard = 3017,
  GreenCard = 3018,
  SubstitutionIn = 3019,
  SubstitutionOut = 3020,
  // Custom incident ID for Cards, as there is no single card incident on API side, but we want to display "Cards" button on UI instead of separate "Yellow card", "Red card" and "Orange card" buttons.
  Cards = 99999,
}
